const modalReason = {
  actionCancel: 'בטל',
  adminLocked: 'מנהל נעול',
  constractTerminated: 'החוזה הסתיים',
  temporarySuspended: 'הושהה זמנית',
  textAreaPlaceholder: 'הזן סיבה',
};

export default modalReason;
